// 森エントランスマップ（Tiny Town タイルセット）
// タイルインデックスは目視で選定（マップ確認しながら調整）
// 行0(0-11): 草、低木、小さい木
// 行1(12-23): 大きい木、岩
// 行2-: 建物・道など
import { MapData } from '../Tilemap';

// 良さげなインデックス
const G = 0; // 草（plain grass）
const T = 6; // 木（小、緑）
const F = 4; // 低木/茂み（fence-like、衝突あり）
const P = 36; // 道（dirt、暫定）

// 26列×18行 (=832x576px after 2x、画面768x480より広め＝カメラスクロール余地あり)
const layout: string[] = [
  'TTTTTTTTTTTTTTTTTTTTTTTTTT',
  'TGGGGGGGGGGGTTGGGGGGGGGGGT',
  'TGFGGGGGGGGGPPGGGGGGGGGFGT',
  'TGGGGGTGGGGGPPGGGGGGTGGGGT',
  'TGGGGGGGGGGGPPGGGGGGGGGGGT',
  'TGGTGGGGGGGGPPGGGGGGGGGTGT',
  'TGGGGGGGGFGGPPGGFGGGGGGGGT',
  'TGGGGGGGGGGGPPGGGGGGGGGGGT',
  'TGGGGGTGGGGGPPGGGGGTGGGGGT',
  'TGGGGGGGGGGGPPGGGGGGGGGGGT',
  'TGFGGGGGGGGGPPGGGGGGGGGFGT',
  'TGGGGGGGTGGGPPGGGGTGGGGGGT',
  'TGGGGGGGGGGGPPGGGGGGGGGGGT',
  'TGGGFGGGGGGGPPGGGGGGGGFGGT',
  'TGGGGGGGTGGGPPGGGGGGGGGGGT',
  'TGGGGGGGGGGGPPGGGGGGGGGGGT',
  'TGGGGGGGGGGGPPGGGGGGGGGGGT',
  'TTTTTTTTTTTTTTTTTTTTTTTTTT',
];

const ground: number[][] = layout.map((row) =>
  Array.from(row).map((c) => (c === 'P' ? P : G)),
);
const walls: number[][] = layout.map((row) =>
  Array.from(row).map((c) => (c === 'T' ? T : c === 'F' ? F : -1)),
);

export const forestMap: MapData = {
  tilesetKey: 'town',
  layers: {
    ground,
    walls,
  },
};

// マップ内の固定スポーン位置（タイル座標）
export const FOREST_SPAWNS = {
  player: { tx: 13, ty: 16 }, // 道の入口（南、中央）
  // 敵を控えめに配置：MVPで遊べる難易度
  enemies: [
    { kind: 'slime' as const, tx: 8, ty: 10 },
    { kind: 'slime' as const, tx: 18, ty: 8 },
    { kind: 'goblin' as const, tx: 6, ty: 6 },
    { kind: 'archer' as const, tx: 20, ty: 5 },
  ],
  boss: { tx: 13, ty: 2 }, // 道の北端
  chest: { tx: 3, ty: 3 },
};
